__turbopack_context__.v({
  "imageFooter": "public-vote-module-scss-module__gOe9Va__imageFooter",
  "logo": "public-vote-module-scss-module__gOe9Va__logo",
  "responsiveButton": "public-vote-module-scss-module__gOe9Va__responsiveButton",
  "votingBox": "public-vote-module-scss-module__gOe9Va__votingBox",
});
